import React, { Fragment, useMemo } from 'react';
import styled from 'styled-components';
import { withRouter, RouteComponentProps } from 'react-router';

interface Props extends RouteComponentProps {
  data?: string;
  overlay?: string;
  onClick?: () => void;
}

const Container = styled.div`
  position: relative;
  text-align: center;
  color: white;
  height: 100%;
  width: 100%;
`;

type OverlayProps = {
  visible: boolean;
};

const Overlay = styled.div<OverlayProps>`
  position: absolute;
  bottom: 0px;
  left: 0px;
  padding: 10px;
  font-size: 20px;
  font-weight: 600;
  background-color: rgba(0, 0, 0, 0.2);
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
`;

const RefreshingImage: React.FunctionComponent<Props> = (props) => {
  const url = useMemo(() => {
    if (props.data && props.data.startsWith('data:')) {
      return 'url(' + props.data + ')';
    }
    return 'url(data:image/jpeg;base64,' + props.data + ')';
  }, [props.data]);

  return (
    <Fragment key={'1'}>
      <Container>
        {props.data && (
          <div
            onClick={props.onClick}
            style={{
              cursor: props.onClick ? 'pointer' : 'default',
              width: '100%',
              height: '100%',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: url,
            }}
          />
        )}
        <Overlay visible={!!props.overlay}>{props.overlay}</Overlay>
      </Container>
    </Fragment>
  );
};

RefreshingImage.whyDidYouRender = true;

export default withRouter(RefreshingImage);
